// extracted by mini-css-extract-plugin
module.exports = {"cohost-form":"CoHost_cohost-form__1QrwZ","form":"CoHost_form__2bB3C","return-home-link":"CoHost_return-home-link__3M7iW","logo":"CoHost_logo__1mlxU"};